query getTotalSwapAmount($type: String, $eth_address: String) {
  getTotalSwapAmount(type: $type, eth_address: $eth_address)
}
